var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spider-chart-container"},[_c('spider-chart',{staticClass:"spider-chart-container__spider-chart",attrs:{"data-screenshot-target":"","dysfunctions":_vm.dysfunctions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }